import { Injectable } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
@Injectable()
export class OffboardingNoteViewService {
  private current: NgbPopover;
  open(view: NgbPopover): void {
    if (this.current && this.current !== view) { this.current.close(); }
    this.current = view; view.open();
  }
  close(view: NgbPopover): void { view.close(); if (this.current === view) { this.current = null; } }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-note-view.service.ts